import {
  configure,
  getAnsiColorFormatter,
  getConsoleSink,
  getJsonLinesFormatter,
  getLogger,
  parseLogLevel,
} from '@logtape/logtape';
import { authLogBufferSink } from './authLogBuffer';

/**
 * Configure LogTape for frontend application
 */
export async function configureLogging() {
  const logLevel = parseLogLevel(
    import.meta.env.VITE_LOG_LEVEL || (import.meta.env.DEV ? 'debug' : 'info'),
  );

  const isProduction = import.meta.env.PROD;
  const isDevelopment = import.meta.env.DEV;

  const formatter = isProduction
    ? getJsonLinesFormatter()
    : isDevelopment
      ? getAnsiColorFormatter()
      : undefined;

  await configure({
    sinks: {
      console: getConsoleSink({ formatter }),
      authBuffer: authLogBufferSink,
    },
    loggers: [
      // #3576: auth is verbose in every environment, console + persistent
      // ring buffer (`serv.authLog()`), until forced re-logins are understood.
      {
        category: ['frontend', 'service', 'auth'],
        lowestLevel: 'debug',
        sinks: ['console', 'authBuffer'],
      },
      {
        category: ['frontend', 'auth'],
        lowestLevel: 'debug',
        sinks: ['console', 'authBuffer'],
      },
      // #3577: "Something went wrong" panels, kept next to the auth trail
      {
        category: ['frontend', 'app', 'errorPanel'],
        lowestLevel: 'debug',
        sinks: ['console', 'authBuffer'],
      },
      // {
      //   category: ['frontend', 'app'],
      //   lowestLevel: logLevel,
      //   sinks: ['console'],
      // },
      // {
      //   category: ['frontend'],
      //   lowestLevel: logLevel,
      //   sinks: ['console'],
      // },
      // {
      //   category: ['frontend', 'service'],
      //   lowestLevel: 'debug',
      //   sinks: ['console'],
      // },
      {
        category: ['logtape', 'meta'],
        lowestLevel: 'error',
        sinks: ['console'],
      },
    ],
  });
}

export const logger = getLogger('frontend');
export const appLogger = logger.getChild('app'); // ???: what is app?
export const apiLogger = logger.getChild('api');
export const layoutLogger = appLogger.getChild('layout');
export const panelStateLogger = appLogger.getChild('panelState');
export const datatableLogger = appLogger.getChild('datatable');
